export default "__VITE_ASSET__029e442f__"